import { ClientInferRequest } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type Payload = ClientInferRequest<typeof contract.users.update>["body"];

export const updateUser = (payload: Payload) => {
  return api.users.update.mutation({ body: payload });
};
